import(/* webpackMode: "eager" */ "/var/www/aiview-score/dashboard/app/global-error.tsx");
